import {
  Box, FormControl, Grid, InputLabel, Select, Table,
  TableBody, TableContainer, TableHead, TableRow
} from "@mui/material";
import axios, { AxiosInstance } from "axios";
import { FC, useState } from "react";
import CheckAttr from "../../../utils/CheckAttr";
import { StyledTableCell, tableStyle } from "../../content/parametrage/Pays/Pays";
import { urlApi } from "../../content/parametrage/Pays/RowPays";
import { useStyles } from "../styles";
import { LoadingButton } from "@mui/lab";
import { AlertType } from "../../../types/AlertType";
import { SnackBarAlert } from "../../element/SnackBarAlert";
import { AllMounth, euroIdDevise } from "../../../constants/Constants";
import Paper from "@mui/material/Paper";
import { DeviseInterface } from "../../content/parametrage/Article/InterfaceArticle";
import RowTauxDechangeForm from "./RowTauxDechangeForm";
import { Taux, TauxInterface } from "../../content/parametrage/TauxEchange/InterfaceTaux";
import SaveIcon from "@mui/icons-material/Save";
import Cookies from "universal-cookie";

interface InputValidation {
  anne: boolean;
  mois: boolean;
  DeviseToCheck: number[];
}

interface TauxDechangeFormProps {
  allDevise: DeviseInterface[];
  rowTauxPerMounthToUpdate?: TauxInterface;
  handleReload: () => void;
  onClose: () => void;
}

const resetInpuValidation: InputValidation = {
  anne: false,
  mois: false,
  DeviseToCheck: [],
};

const dataYears = [
  new Date().getFullYear(),
  new Date().getFullYear() + 1,
];

const TauxDechangeForm: FC<TauxDechangeFormProps> = ({
  allDevise,
  rowTauxPerMounthToUpdate,
  handleReload,
  onClose
}) => {
  const classes = useStyles();
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // autre
  const [alertType, setAlertType] = useState<AlertType>("success");
  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const handleCloseAlert = () => {
    setOpenSnack(false);
  };
  const [isClickSave, setIsClickSave] = useState<boolean>(false);

  const [errorInput, setErrorInput] =
    useState<InputValidation>(resetInpuValidation);

  // Validation Input
  const isValidate = (): boolean => {
    // Reinitialise les variables des validations
    setErrorInput(resetInpuValidation);
    // Teste Des Taux Childs
    const AllDeviseId = allDevise
      ?.filter((dev) => dev.id != euroIdDevise)
      ?.map((dev) => dev?.id);
    const AllDeviseIdCheckAttr = TauxPerMounth?.taux
      ?.filter((tx) => tx?.rate_euro !== "")
      ?.map((tx) => tx?.devise_id);
    const AllDeviseIdToCheck = AllDeviseId?.filter(
      (dev) => !AllDeviseIdCheckAttr?.includes(dev)
    );

    if (
      !CheckAttr(TauxPerMounth?.annee) ||
      TauxPerMounth?.annee == 0 ||
      !CheckAttr(TauxPerMounth?.mois) ||
      TauxPerMounth?.mois == 0 ||
      AllDeviseIdToCheck.length != 0
    ) {
      !CheckAttr(TauxPerMounth?.annee) ||
        (TauxPerMounth?.annee == 0 &&
          setErrorInput((prev: InputValidation) => ({
            ...prev,
            anne: true,
          })));
      !CheckAttr(TauxPerMounth?.mois) ||
        (TauxPerMounth?.mois == 0 &&
          setErrorInput((prev: InputValidation) => ({
            ...prev,
            mois: true,
          })));

      AllDeviseIdToCheck.length != 0 &&
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          DeviseToCheck: AllDeviseIdToCheck,
        }));
      setAlertType("warning");
      setAlerteMessage(
        "Merci de saisir des taux pour les champs en rouge SVP !"
      );
      setOpenSnack(true);
      return false;
    }
    return true;
  };

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  const [TauxPerMounth, setTauxPerMounth] = useState<TauxInterface>(
    rowTauxPerMounthToUpdate as TauxInterface
  );

  // HandleChange
  const handleChangeTaux = (tauxByRow: string, idDevise: number) => {
    // Si Ajout alors []
    const tauxTempArray =
      TauxPerMounth?.taux === undefined ? [] : TauxPerMounth?.taux;
    const index = tauxTempArray?.findIndex((t) => t.devise_id == idDevise);

    if (index == -1 || index === undefined) {
      // CREATE
      const TauxCreated: Taux = {
        annee: TauxPerMounth?.annee,
        mois: TauxPerMounth?.mois,
        devise_id: idDevise,
        rate_euro: tauxByRow,
      };
      tauxTempArray?.push(TauxCreated);
    } else {
      // Updated
      const tauxTemp = tauxTempArray?.find((t) => t.devise_id == idDevise);
      const tauxTempResultat = {
        ...tauxTemp,
        rate_euro: tauxByRow,
      };
      tauxTempArray[index] = tauxTempResultat as Taux;
    }
    setTauxPerMounth({
      ...TauxPerMounth,
      taux: tauxTempArray,
    });
  };

  const handleSave = () => {
    if (isValidate()) {
      setIsClickSave(true);
      http.post('taux-exchange/save', TauxPerMounth)
        .then((res) => {
          if (typeof res.data == "string") {
            // Rednandace
            setAlertType("warning");
            setAlerteMessage(res.data);
            setOpenSnack(true);
          } else {
            onClose();
            handleReload();
          }
        })
        .catch((error) => {
          console.log(error);
        }).finally(() => setIsClickSave(false));
    }
  };

  return (
    <>
      <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
        <Grid item xs={6} sm={6} md={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <InputLabel
              htmlFor="pays"
              color="warning"
            >
              Année
            </InputLabel>
            <Select
              id="year"
              native
              color="warning"
              error={errorInput.anne}
              value={TauxPerMounth?.annee}
              onChange={(e) => {
                setTauxPerMounth({
                  ...TauxPerMounth,
                  annee: Number(e.target.value),
                });
              }}
              label="year"
              inputProps={{
                name: "year",
              }}
            >
              <option value={0}></option>
              {dataYears.map((y) => (
                <option value={y}>{y}</option>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={6} sm={6} md={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <InputLabel
              htmlFor="pays"
              color="warning"
            >
              Mois
            </InputLabel>
            <Select
              id="Mois"
              native
              color="warning"
              error={errorInput.mois}
              value={TauxPerMounth?.mois}
              onChange={(e) => {
                setTauxPerMounth({
                  ...TauxPerMounth,
                  mois: Number(e.target.value),
                });
              }}
              label="Mois"
            >
              <option value={0}></option>
              {AllMounth.map((m) => (
                <option value={m.id}>{m.mounth}</option>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <br></br>

      <TableContainer component={Paper} style={tableStyle}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">Devise</StyledTableCell>
              <StyledTableCell align="center">Taux Euro</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allDevise?.map(
              (devise) =>
                devise?.id != euroIdDevise && (
                  <RowTauxDechangeForm
                    rowDevise={devise}
                    TauxPerMounth={TauxPerMounth}
                    handleChangeTaux={handleChangeTaux}
                    DeviseToCheck={errorInput?.DeviseToCheck}
                  />
                )
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {stackAlert}

      <Box display="flex" justifyContent="center" mt={5}>
        <LoadingButton
          onClick={() => handleSave()}
          endIcon={<SaveIcon />}
          loading={isClickSave}
          loadingPosition="end"
          sx={{ textTransform: "none" }}
          variant="contained"
          color="warning"
        >
          Enregistrer
        </LoadingButton>
      </Box>
    </>
  );
};

export default TauxDechangeForm;
